import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=3ebdc971&scoped=true"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"
import style0 from "./blog.vue?vue&type=style&index=0&id=3ebdc971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebdc971",
  null
  
)

export default component.exports